import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { ITimeSettings } from '../../definitions/Shared'
import TimeHelper from '../../helpers/TimeHelper'
import _ from 'lodash'
import { IMessage } from '../../definitions/AIQuery'
import { IUser } from '../../definitions/Users'

export interface IInitial {
    mode: 'light' | 'dark'
    spotlight: {
        history: {
            id: string
            params?: any
        }[]
    }
    timeSettings: ITimeSettings
    aiQueryMessages: IMessage[]
    currentUser: IUser
    customColors: string[]
}

const INITIAL: IInitial = {
    mode: window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light',
    spotlight: { history: [] },
    timeSettings: TimeHelper.timeSettings(),
    aiQueryMessages: [],
    currentUser: null,
    customColors: []
}

const appSlice = createSlice({
    name: 'app',
    initialState: INITIAL,
    reducers: {
        changeMode: (state, action: PayloadAction<IInitial['mode']>) => {
            state.mode = action.payload
        },
        addAIQueryMessage: (state, action: PayloadAction<IMessage>) => {
            if (!state.aiQueryMessages) state.aiQueryMessages = []

            state.aiQueryMessages = [...state.aiQueryMessages, action.payload]
        },
        setAIQueryMessages: (state, action: PayloadAction<IMessage[]>) => {
            state.aiQueryMessages = action.payload
        },
        addSpotlightSearch: (state, action: PayloadAction<IInitial['spotlight']['history'][0]>) => {
            if (!state.spotlight) state.spotlight = { history: [] }
            if (!state.spotlight.history) state.spotlight.history = []

            const index = state.spotlight.history.findIndex(x => x.id === action.payload.id)
            if (index > -1) state.spotlight.history.splice(index, 1)

            state.spotlight.history = _.takeRight([...state.spotlight.history, action.payload], 10)
        },
        setTimeSettings: (state, action: PayloadAction<ITimeSettings>) => {
            state.timeSettings = action.payload
        },
        setCurrentUser: (state, action: PayloadAction<IUser>) => {
            state.currentUser = action.payload
        },
        clearCurrentUser: state => {
            state.currentUser = null
        },
        setCustomColors: (state, action: PayloadAction<string[]>) => {
            state.customColors = action.payload
        },
        clearCustomColors: state => {
            state.customColors = []
        },
        addCustomColor: (state, action: PayloadAction<string>) => {
            if (!state.customColors) state.customColors = []
            const color = action.payload

            if (!state.customColors.includes(color)) {
                if (state.customColors.length >= 4) {
                    state.customColors = [...state.customColors.slice(1), color]
                } else {
                    state.customColors = [...state.customColors, color]
                }
            }
        },
        removeCustomColor: (state, action: PayloadAction<string>) => {
            if (!state.customColors) return
            state.customColors = state.customColors.filter(x => x !== action.payload)
        }
    }
})

export const { changeMode, addAIQueryMessage, setAIQueryMessages, addSpotlightSearch, setTimeSettings, setCurrentUser, clearCurrentUser, setCustomColors, clearCustomColors, addCustomColor, removeCustomColor } = appSlice.actions
export default appSlice.reducer
